var $22e2db7c7059f55f$exports = {};
$22e2db7c7059f55f$exports = {
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "loadingMore": `\u{62C}\u{627}\u{631}\u{64D} \u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}...`
};


export {$22e2db7c7059f55f$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
